/**
 * Created by bhadaway on 2/22/18.
 */
import { createStore } from 'redux';
import middleware from './Middleware/index';
import reducer from './Reducers/index'

export default createStore(reducer, middleware)